import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';

import Pusher from 'pusher-js';
import { environment } from '../../environments/environment';
import {AuthService} from "./auth.service";

declare global {
  interface Window {
    Echo: any;
    Pusher: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class EchoService {

  constructor(private authService: AuthService) {
    this.authService.token().subscribe(token => {

      window.Pusher = Pusher;
      window.Echo = new Echo({
        broadcaster: 'reverb',
        key: environment.reverbAppKey,
        wsHost: environment.reverbHost,
        wsPort: environment.reverbPort,
        wssPort: environment.reverbPort,
        forceTLS: environment.reverbScheme === 'https',
        encrypted: true,
        enabledTransports: ['ws', 'wss'],
        authEndpoint: environment.api.broadcastingUrl,
        auth: {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      });

      window.Echo.connector.pusher.connection.bind('error', function(err) {
        if (err.data.code === 4004) {
          console.log('Detection limit exceeded'); // Handle specific errors
        }
        console.log(err); // General error logging
      });

    });
  }

  getEcho(): Echo<any> | null {
    return window.Echo || null;
  }

  disconnect(): void {
    if (window.Echo) {
      try {
        window.Echo.disconnect();
      } catch (error) {
        console.error('Error disconnecting Echo:', error);
      }
      window.Echo = null;
    }
  }

  /*
  auth: {
    headers: {
      Authorization: 'Bearer ' + this.token,
      // or if you're using cookie-based auth
      'X-CSRF-TOKEN': 'token-from-meta-tag'
    }
  },
  */

}
